import { IconDone } from 'icons/components/IconDone'

export const data = {
	default: {
		title: 'subscribe.feedback.snackbar.title',
		icon: <IconDone color='content-inverse' />,
	},
	discount: {
		title: 'subscribe.feedback.snackbar.discount.title',
		subtitle: 'subscribe.feedback.snackbar.discount.subtitle',
		icon: <IconDone color='content-inverse' />,
	},
}
